import { useTranslation } from 'react-i18next'
import NavDropdown from '@/components/layout/NavDropdown'
import './index.less'

const LANGS = [
  { value: 'en', label: 'English' },
  { value: 'zh', label: 'Chinese' },
]

interface LanguageSwitcherProps {
  compact?: boolean
}

const LanguageSwitcher = ({ compact = false }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation()
  const currentLang = i18n.language?.startsWith('zh') ? 'zh' : 'en'

  const handleSelect = (item: { value?: string }) => {
    if (!item.value) return
    i18n.changeLanguage(item.value)
    document.documentElement.lang = item.value
  }

  return (
    <div className="lang-switcher">
      <NavDropdown
        label={currentLang === 'en' ? 'EN' : '中文'}
        items={LANGS}
        selectedValue={currentLang}
        onSelect={handleSelect}
        align="right"
        compact={compact}
        openOnHover={!compact}
        menuTheme="gray"
      />
    </div>
  )
}

export default LanguageSwitcher
